(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-cart-extras"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => root.querySelectorAll('[data-wv-review-carousel]').forEach(carousel => {
    if (carousel.dataset.reviewReady) return;
    carousel.dataset.reviewReady = 'true';
    const track = carousel.querySelector('[data-review-track]');
    const cards = [...track.querySelectorAll('.wv-cart-review:not(.wv-cart-review-draft)')];
    const controls = carousel.querySelector('[data-review-controls]');
    if (!controls || cards.length < 2) return;
    const prev = controls.querySelector('[data-review-prev]'), next = controls.querySelector('[data-review-next]'), counter = controls.querySelector('[data-review-count]');
    let active = 0, frame = 0;
    const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    const update = () => {
      frame = 0;
      const max = Math.max(0,track.scrollWidth - track.clientWidth);
      active = Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/step())));
      controls.hidden = max < 2;
      prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft >= max - 2;
      const visible = Math.max(1,Math.floor((track.clientWidth+18)/step()));
      const end = Math.min(cards.length,active+visible);
      counter.textContent = (visible > 1 ? `${active+1}–${end}` : `${active+1}`) + ` / ${cards.length}`;
    };
    const move = index => track.scrollTo({left:Math.max(0,index)*step(),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    prev.addEventListener('click',()=>move(active-1)); next.addEventListener('click',()=>move(active+1));
    track.addEventListener('scroll',()=>{if(!frame) frame=requestAnimationFrame(update);},{passive:true});
    track.addEventListener('keydown',event=>{if(event.target!==track)return;const indexes={ArrowLeft:active-1,ArrowRight:active+1,Home:0,End:cards.length-1};if(event.key in indexes){event.preventDefault();move(indexes[event.key]);}});
    new ResizeObserver(update).observe(track); update();
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize(document)); else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target.parentElement||document));
  document.addEventListener('wv:cart:rendered',()=>initialize(document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wv-customer-reviews')) {
  customElements.define('wv-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.track = this.querySelector('[data-review-track]');
      if (!this.track) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.cards = Array.from(this.track.querySelectorAll('.wv-customer-review'));
      this.dots = Array.from(this.querySelectorAll('[data-review-index]'));
      this.dotLabel = this.querySelector('[data-review-dot-label]')?.dataset.reviewDotLabel || '';
      this.mobile = matchMedia('(max-width: 600px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-open-review]');
      this.current = 0;
      this.dots.forEach(dot => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.reviewIndex)), options));
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      }, { passive: true, signal: this.abort.signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      window.addEventListener('resize', () => this.update(), options);
      this.opener?.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.dialog?.showModal();
      }, options);
      this.querySelector('[data-close-review]')?.addEventListener('click', () => this.dialog?.close(), options);
      this.dialog?.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog?.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
      if (this.dialog?.querySelector('[data-review-feedback]')) this.dialog.showModal();
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
      this.ready = false;
    }
    maxIndex() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const start = this.cards[0]?.offsetLeft || 0;
      return this.cards.reduce((last, card, index) => card.offsetLeft - start <= maximum + 2 ? index : last, 0);
    }
    goTo(index) {
      if (!this.cards.length) return;
      const target = Math.max(0, Math.min(index, this.maxIndex()));
      const left = this.cards[target].offsetLeft - this.cards[0].offsetLeft;
      this.track.scrollTo({ left, behavior: this.motion.matches ? 'auto' : 'smooth' });
    }
    update() {
      if (!this.cards.length) return;
      const start = this.cards[0].offsetLeft;
      let closest = 0;
      let distance = Infinity;
      this.cards.forEach((card, index) => {
        const value = Math.abs(card.offsetLeft - start - this.track.scrollLeft);
        if (value < distance) { closest = index; distance = value; }
      });
      const maximum = this.maxIndex();
      closest = Math.min(closest, maximum);
      this.current = closest;
      const firstDot = Math.max(0, Math.min(closest - 1, maximum - this.dots.length + 1));
      this.dots.forEach((dot, position) => {
        const index = Math.min(firstDot + position, maximum);
        dot.hidden = position > maximum;
        dot.dataset.reviewIndex = String(index);
        dot.setAttribute('aria-label', this.dotLabel.replace('__number__', String(index + 1)));
        dot.setAttribute('aria-controls', this.cards[index].id);
        if (index === closest) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
